import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getNumberInputTestIds = createTestIds('number-input', [
  'control',
  'plus',
  'minus',
  ...elements
] as const);

export const getNumberRangeTestIds = createTestIds('number-range', [
  'min',
  'max',
  ...elements
] as const);
